export enum DermloopReportTypeEnum {
  DK_AUDIT_LOG = 'DK_AUDIT_LOG',
}

export enum DermloopReportStatusEnum {
  PENDING = 'PENDING',
  GENERATED = 'GENERATED',
  DOWNLOADED = 'DOWNLOADED',
  FAILED = 'FAILED',
}
